import { render, staticRenderFns } from "./myFollowStore.vue?vue&type=template&id=ce013508&scoped=true"
import script from "./myFollowStore.vue?vue&type=script&lang=js"
export * from "./myFollowStore.vue?vue&type=script&lang=js"
import style0 from "./myFollowStore.vue?vue&type=style&index=0&id=ce013508&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce013508",
  null
  
)

export default component.exports